<template>
  <div v-on:click="closePopup()" class="global-popup xxzz" v-if="popup">
    <p class="zzz">{{$store.getters.globalPopup}}</p>
    <PopupShare v-bind:closePopup="closePopup" v-if="popup == 'share'" />
    <PopupDelete v-bind:closePopup="closePopup" v-if="popup == 'delete'" />
    <PopupExport v-bind:closePopup="closePopup" v-if="popup == 'export'" />
    <PopupUpgrade v-bind:closePopup="closePopup" v-if="popup == 'too_many'" />
  </div>
</template>

<script>
const axios = require('axios')

import PopupShare from './PopupShare'
import PopupDelete from './PopupDelete'
import PopupExport from './PopupExport'
import PopupUpgrade from './PopupUpgrade'

export default {
  name: 'PopupUpgrade',
  data () {
    return {
      comments: '',
      shareEmails: '',
      shareType: 'view'
    }
  },
  props: ['closePopup', 'popup'],
  components: {
    PopupShare,
    PopupDelete,
    PopupExport,
    PopupUpgrade
  },
  methods: {
  },
  computed: {

  },
  watch: {
  },
  mounted () {
  },
  created () {
    // console.log('==>', this.$route);
    // console.log('====>', this.$store.getters.globalPopup);
    this.$store.watch(() => {
      return this.$store.getters.myProjectListWithDetails
    }, () => {
      // console.log('---->')
    })
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'ADD_PROJECT':
          setTimeout(() => {
            this.myProjectDetailsList = this.$store.getters.myProjectListWithDetails
          }, 100)
          break
        case 'REMOVE_PROJECT':
          setTimeout(() => {
            this.myProjectDetailsList = this.$store.getters.myProjectListWithDetails
          }, 100)
          break
      }
    })
    this.$store.watch(() => {
      return this.$store.getters.myProjectListWithDetailsFull
    }, () => {
      // console.log('---->')
    })
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'ADD_PROJECT_FULL':
          setTimeout(() => {
            this.myProjectDetailsListFull = this.$store.getters.myProjectListWithDetailsFull
          }, 100)
          break
      }
    })
  }
}
</script>

<style scoped lang="scss">
  .xxzz {
    /*position: sticky;*/
    top: 0;
  }
  .zzz {
    position: absolute;
    top: 0;
    color: white;
  }
</style>
